import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20technology%20background%20with%20soft%20warm%20beige%20and%20cream%20gradient%2C%20geometric%20flowing%20shapes%20and%20subtle%20curves%2C%20clean%20sophisticated%20design%2C%20atmospheric%20soft%20lighting%2C%20high%20end%20tech%20brand%20visual%2C%20elegant%20composition&width=1800&height=900&seq=hlw-hero-bg&orientation=landscape"
          alt="hlw 平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 md:mb-6 tracking-tight">
          {t('home.hero.title')}
        </h1>
        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {t('home.hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4">
          <a
            href="#cta"
            className="px-8 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-md text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            {t('home.hero.cta')}
          </a>
          <a
            href="#features"
            className="px-8 py-3 bg-background-50/15 text-background-50 backdrop-blur-sm rounded-md text-sm md:text-base font-medium hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
          >
            {t('home.hero.secondary')}
          </a>
        </div>
      </div>
    </section>
  );
}